const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchSubscriptionData = async (inviter_code, initData, cash) => {
    try {
        const headers = {
            "Content-Type": "application/json",
            'ngrok-skip-browser-warning': 'true'
        };

        // Если нет initData, пробуем fallback JWT из localStorage
        const fallbackToken = localStorage.getItem('fallback_access_token');
        if (!initData && fallbackToken) {
            headers['Authorization'] = `Bearer ${fallbackToken}`;
        } else if (!initData) {
            throw new Error('Отсутствуют данные инициализации');
        }

        const response = await fetch(`${API_BASE_URL}/user-info`, {
            method: "POST",
            headers,
            body: JSON.stringify({
                inviter_code,
                initData: initData || undefined,
                cash
            })
        });

        if (!response.ok) {
            throw new Error('Ошибка при получении данных подписки');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка в fetchSubscriptionData:', error);
        return null;
    }
};
